import { createAsyncThunk } from "@reduxjs/toolkit";
import { WarehouseAxios } from "api/WarehouseAxios";
import axios from "axios";

export const fetchDamages = createAsyncThunk(
  "damage/fetchDamages",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
    wharehouse_id,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
    wharehouse_id?: string;
  }) => {
    const params = new URLSearchParams();
    params.append("page", page.toString());
    params.append("page_size", pageSize.toString());
    if (search) params.append("search", search);
    if (sort) {
      const orderingValue = order === "desc" ? `-${sort}` : sort;
      params.append("ordering", orderingValue);
    }

    if (filters && filters.length > 0) {
      filters.forEach(
        ({
          filterField,
          filterValue,
        }: {
          filterField: string;
          filterValue: any;
        }) => {
          if (
            filterField &&
            filterValue !== undefined &&
            filterValue !== null
          ) {
            if (typeof filterValue === "object" && filterValue !== null) {
              // Handle cases like { from_date: ..., to_date: ... }
              Object.entries(filterValue).forEach(([key, value]) => {
                if (value !== undefined && value !== null && value !== "") {
                  params.append(key, String(value));
                }
                if (
                  (filterValue.from_date || filterValue.to_date) &&
                  (filterField === "created_at" || filterField === "updated_at")
                ) {
                  if (filterField === "created_at") {
                    filterField = "created";
                  } else {
                    filterField = "updated";
                  }
                  params.append("filter_by", filterField);
                }
              });
            } else {
              // Handle primitive values (string, number)
              params.append(filterField, filterValue);
            }
          }
        }
      );
    }
    // const response: any = await axios.get(
    //   `/project-warehouse/damage-data/?${params.toString()}`
    // );
    const response: any = await WarehouseAxios.get(
      `/project-warehouse/damage_data/?warehouse_id=${wharehouse_id}&${params.toString()}`
    );

    return {
      // data: response?.data || [],
      data: response?.data?.data || [],
      rowCount: response?.data?.count || 0,
    };
  }
);

export const exportDraftRFQCSV = async () => {
  const response = await WarehouseAxios.get(
    "/warehouse/dailyLogs/?export=csv",
    {
      responseType: "blob",
    }
  );

  return {
    blob: response.data,
    filename:
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") || "purchaseRequest.csv",
  };
};
